import cn from 'classnames';
import Image from 'next/legacy/image';
import Router from 'next/router';
import { Button, Grid } from 'ht-styleguide';
import { POPULAR_SERVICES } from '../locationPage.constants';
import styles from '../locationPage.module.scss';
import { skuCatPath } from '@constants/paths';

type PopularServicesProps = {
  location: string;
  onButtonClick: BaseAnyFunction;
  buttonText?: string;
  isMobile: boolean;
};

function goToCategoryPage(page: string) {
  Router.push(page);
}

const PopularServices = ({ location, onButtonClick, buttonText = 'See More Services', isMobile }: PopularServicesProps) => (
  <Grid.Fluid classes="paddingY-huge">
    <h3 className="paddingBottom-large2 text-align-center">Most Popular Services in {location}</h3>
    <Grid.Row>
      {POPULAR_SERVICES.map(service => (
        <Grid.Column sm={4} lg={6} key={service.serviceName} classes={cn('paddingBottom-large', styles.popularImage)}>
          <div className="cursorPointer" onClick={() => goToCategoryPage(skuCatPath(service.link))}>
            <Image
              alt={service.serviceName}
              layout="responsive"
              height={115}
              width={340}
              src={isMobile ? service.imageMobile : service.image}
              quality={75}
            />
            <h4 className="paddingTop-small2">{service.serviceName}</h4>
          </div>
          <p className="paddingTop-small p1 n700">{service.text}</p>
        </Grid.Column>
      ))}
    </Grid.Row>
    <Grid.Row>
      <Grid.Column smOffset={1} sm={2} mdOffset={3} md={2} lgOffset={5} lg={2}>
        <Button onClick={onButtonClick}>{buttonText}</Button>
      </Grid.Column>
    </Grid.Row>
  </Grid.Fluid>
);

export default PopularServices;
